

import shader from "./shader/FogShader"
class Fog {
    constructor(option) {
        option = option || {};
        this._fogByDistance = option.fogByDistance || { near: 10, nearValue: 0, far: 20000, farValue: 1.0 }
        this._color = option.color || new Cesium.Color(248/255, 246/255, 242/255, 1)
        this._delegate = undefined;
    }

    add() {
        if (this._delegate) {
            return;
        }

        this._delegate = new Cesium.PostProcessStage({
            fragmentShader: shader,
            uniforms: {
                fogByDistance: new Cesium.Cartesian4(
                    this._fogByDistance.near,
                    this._fogByDistance.nearValue,
                    this._fogByDistance.far,
                    this._fogByDistance.farValue
                ),
                fogColor: this._color
            }
        })

        viewer.scene.postProcessStages.add(this._delegate)

    }

    remove() {

        if (this._delegate) {
            viewer.scene.postProcessStages.remove(this._delegate)
            this._delegate = undefined;
        }

    }
}

export default Fog;